import * as React from 'react';
import Modal from 'react-responsive-modal';
import axios from 'axios';
import { RenderPointsRelais } from './RenderPointsRelais';
import { getUserId, sessionExpire } from './MonCompteAction';
import { Order } from './iMonCompte';
import { getHostApi, getRequestConfig } from '../../utils';

interface RenderChoixEtiquetteState {
  prIsVisible: boolean;
  open: boolean;
  order?: Order;
}

interface RenderChoixEtiquetteProps {
  onTransporteurChanged(transporteurId: string): void;

  transporteurs: any[];
  orderId: number;
  retourId?: any;
}

export default class RenderChoixEtiquette extends React.Component<RenderChoixEtiquetteProps,
  RenderChoixEtiquetteState> {

  constructor(props: RenderChoixEtiquetteProps) {
    super(props);
    this.state = {
      prIsVisible: false,
      open: false,
    };

    this.onTransporteurClick = this.onTransporteurClick.bind(this);
  }

  componentWillMount() {
    this._getOrder();
  }

  componentDidMount() {
    this._emitTransporteurChanged(this.props.transporteurs[0].id);
  }

  /**
   * Fonction retournant le détail d'une commande
   *
   * @private
   */
  _getOrder = () => {
    axios.get(getHostApi() + '/customers/' + getUserId() + '/orders/' + this.props.orderId, getRequestConfig()).then((response) => {
      if (response.data.order) {
        this.setState({ order: response.data.order });
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  onTransporteurClick(event: React.ChangeEvent<HTMLSelectElement>) {
    this._emitTransporteurChanged(event.target.value);
  }

  _emitTransporteurChanged(id: any) {
    if (this.props.onTransporteurChanged) {
      this.props.onTransporteurChanged(id);

      this.setState({
        prIsVisible: id != 1,
      });
    }
  }

  onOpenModal = () => {
    this.setState({ open: true });
  }

  onCloseModal = () => {
    this.setState({ open: false });
  }

  _getFullAddress() {
    return this.state.order?.Adresse1Livraison + ' ' + this.state.order?.CodePostalLivraison + ' ' +
      this.state.order?.VilleLivraison;
  }

  render() {
    const transporteurs: any[] = this.props.transporteurs.reverse().map((transporteur) => {
      return <option key={transporteur.id} value={transporteur.id}>{transporteur.libelle}</option>;
    });

    const renderModal = () => {
      if (this.state.order) {
        return (
          <Modal open={this.state.open} onClose={this.onCloseModal} center
                 classNames={{ overlay: 'bootstrap-container', modal: 'pointsRelaisModalContainer customModal',
                   closeButton: 'pointsRelaisModalCloseButton closeButton'}}>
            <div className="modalPR p-2" style={{ maxHeight: '740px' }}>
              <RenderPointsRelais orderId={this.props.orderId} defaultAddress={this._getFullAddress()}
                                  retourId={this.props.retourId} showButtons={false}/>
            </div>
          </Modal>
        );
      }
    };

    const renderPR = () => {
      if (this.state.prIsVisible) {
        return (
          <div className="py-2 ml-3 font14">
            <div>
              Déposer votre colis dans <span className="bold"> le point relais UPS de votre choix </span>
            </div>
            <a href="#" className="cursor-pointer text-underline " onClick={this.onOpenModal}>
              Consulter la liste des points de dépôt
            </a>
          </div>
        );
      }
    };

    return (
      <div className="p-3 d-flex flex-row align-items-baseline border-bottom">
        <div>
          <span>Retour par :&nbsp;</span>
          <select onChange={this.onTransporteurClick}>
            {transporteurs}
          </select>
        </div>
        {renderPR()}
        {renderModal()}
      </div>
    );
  }
}
